import DividerContainer from "../../../Components/UiKits/Divider/DividerContainer";

const Divider = () => {
  return <DividerContainer />;
};

export default Divider;
